import React from 'react';
import { useParams } from 'react-router-dom';
import { useIntl } from 'react-intl';

import Box from '@mui/material/Box';

import BackButton from '@ts-core/components/BackButton';

import MultipleChoiceExercisePage from 'modules/multipleChoiceExercises/pages/MultipleChoiceExercisePage';
import FillInTheBlanksExercisePage from 'modules/fillInTheBlanksExercises/pages/FillInTheBlanksExercisePage';

const ExercisePageHandler = () => {
  const { courseId, subjectId, type } = useParams<{ courseId: string; subjectId: string; type: string; exerciseId?: string }>();
  const intl = useIntl();

  function renderExercisePage() {
    if (type === 'FillInTheBlanksExercise') {
      return <FillInTheBlanksExercisePage />;
    }
    return <MultipleChoiceExercisePage />;
  }

  function getBackButtonTitle(): string {
    if (type === 'FillInTheBlanksExercise') {
      return intl.formatMessage({ id: 'exercise.types.FillInTheBlanksExercise' });
    }
    return intl.formatMessage({ id: 'exercise.types.AbstractExercise' });
  }

  return (
    <Box>
      <BackButton
        title={getBackButtonTitle()}
        subtitle={intl.formatMessage({ id: 'tab.exercises' })}
        href={`/${courseId}/subjects/${subjectId}/exercises`}
      />
      {renderExercisePage()}
    </Box>
  );
};

export default ExercisePageHandler;
